<style lang="scss" scoped>
    button {
        // height: 60px;
        padding: 10px 20px;
        background: var(--v-action-base);
        border-radius: 8px;

        font-weight: 700;
        font-size: 18px;
        line-height: 25px;
        color: #FFFFFF;

        &.disabled {
            background: #D0D0D0 !important; 
            font-weight: 400;
        }

        &.white {
            background: white !important;
            color: rgba(82, 82, 82, 0.6);
            font-weight: 400;
            border: 1px solid #525252 !important;
        }
    }
</style>

<template>
    <button 
        @click.prevent="!disabled && !loading && $emit('click')" 
        :class="classes" 
        :style="{height}"
        >
        <slot></slot>

        <v-progress-circular
            v-if="loading"
            indeterminate
            size="16"
            width="2"
            class="ml-1"
            />
    </button>
</template>

<script>
export default {
    props: {
        loading: Boolean,
        disabled: Boolean,
        white: Boolean
    },
    computed: {
        height() {
            let height = {
            'xs': 75,
            'sm': 75,
            'md': 45,
            'lg': 45,
            'xl': 60
            }

        return (height[this.$vuetify.breakpoint.name] || 60)+"px";
        },
        classes() {
            return { 
                disabled: this.disabled, 
                white: this.white
            };
        }
    }
}
</script>